import React, { createContext, useContext, useState, ReactNode } from "react";

interface PunchoutContextType {
  isPunchoutSession: boolean;
  setIsPunchoutSession: (value: boolean) => void;
}

const PunchoutContext = createContext<PunchoutContextType | undefined>(
  undefined
);

export const usePunchout = () => {
  const context = useContext(PunchoutContext);
  if (context === undefined) {
    throw new Error("usePunchout must be used within a PunchoutProvider");
  }
  return context;
};

interface PunchoutProviderProps {
  children: ReactNode;
}

export const PunchoutProvider: React.FC<PunchoutProviderProps> = ({
  children,
}) => {
  const [isPunchoutSession, setIsPunchoutSession] = useState(false);

  return (
    <PunchoutContext.Provider
      value={{ isPunchoutSession, setIsPunchoutSession }}
    >
      {children}
    </PunchoutContext.Provider>
  );
};
